<template>
  <el-form class="repair-done" label-width="120px">
    <template v-if="form.verifyType">
      <el-form-item label="下一步">
        <el-select v-model="form.nextstep">
          <el-option
            v-for="(step, index) of nextStepList"
            :key="`stepInfo-${index}`"
            :value="step.nodeId"
            :label="step.nodeName"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="修复信息">
        <el-input type="textarea" v-model="form.repairContent"
         placeholder="请输入修复信息"></el-input>
      </el-form-item>
      <el-form-item label="备注">
        <el-input type="textarea" v-model="form.description">
        </el-input>
      </el-form-item>
      <el-form-item label="附件信息">
        <el-upload
          ref="upload"
          action=""
          list-type="picture-card"
          :limit="3"
          :on-exceed = "handleExceed"
          :before-remove = "beforeRemove"
          :before-upload = "handleBeforeUpload"
          :on-change = "handleOnChange"
          accept=".png,.jpg,.jpeg"
          :http-request="modeUpload"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>
    </template>
    <el-form-item>
      <el-button size="small" type="primary" @click="onSubmit">确认</el-button>
      <el-button size="small" @click="onCancel">取消</el-button>
    </el-form-item>
  </el-form>
</template>
<script>
import {
  getNextStepInfo, auditOrder,
  uploadImagesGD,
} from '@/api/equipment-operational/index';
import { convertDataToFormData } from '@/utils/utils';
import DiaFormMixin from '@/components/operating-maintenance/mixins/dia-form-mixin';

export default {
  name: 'arrive-sence',
  mixins: [DiaFormMixin],
  props: {
    selectProcessInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    // 上传检测
    // eslint-disable-next-line no-unused-vars
    const validateFileUrl = (rule, value, callback) => {
      console.log(this.$refs.upload.uploadFiles.length);
      if (this.$refs.upload.uploadFiles.length < 1) {
        // this.$refs.upload 打印判断条件
        callback(new Error('请上传文件'));
      } else {
        callback();
      }
    };
    return {
      form: {
        taskId: null,
        verifyType: true,
        nextstep: '',
        // auditers: {},
        // 修复信息
        repairContent: '',
        description: '',
      },
      mode: [],
      zform: {},
      zrules: {
        name: [
          {
            required: true,
            message: '请输入',
            trigger: 'blur',
          },
        ],
        // 校验文件
        file: [
          { required: true, validator: validateFileUrl, trigger: 'change' },
        ],
      },
      fileList: [],
      file: undefined,
      pic: {},
      nextStepList: [],
      dialogImageUrl: '',
      dialogVisible: false,
      formLabelWidth: '80px',
      limitNum: 3,
    };
  },
  created() {
    this.initialFormData();
    this.requestNextStepList();
  },
  watch: {
    selectProcessInfo() {
      this.initialFormData();
      this.requestNextStepList();
    },
  },
  methods: {
    // 初始化表单数据
    initialFormData() {
      this.form.taskId = this.selectProcessInfo.F_TaskId;
    },
    // 提交申请
    onSubmit() {
      this.submitAudit();
    },
    // 取消申请
    onCancel() {
      this.emitCloseDialog();
    },
    // 提交审核
    submitAudit() {
      this.formatForm();
      const formData = convertDataToFormData(this.form);
      auditOrder(formData).then((res) => {
        if (res.state === 'success') {
          if (this.mode.length <= 0) {
            this.notifyDataChanged();
            this.emitCloseDialog();
          } else {
            this.zsubmitForm();
          }
        }
      });
    },
    formatForm() {
      const repairData = this.form.repairContent; // 修复信息
      this.form.formData = JSON.stringify(repairData);
      // const auditers = [{}];
      // this.form.auditers = JSON.stringify(auditers);
      // 审核结果 转换 （1、通过；2、拒绝）
      if (this.form.verifyType) {
        this.form.verifyType = 1;
      } else {
        this.form.verifyType = 2;
      }
    },
    requestNextStepList() {
      if (this.selectProcessInfo == null) {
        return;
      }
      getNextStepInfo({
        isNew: false,
        processId: this.selectProcessInfo.F_Id,
        schemeCode: this.selectProcessInfo.F_SchemeCode,
        taskId: this.selectProcessInfo.F_TaskId,
        formData: '',
      }).then((res) => {
        this.nextStepList = res;
        const [nextStep] = res;
        this.form.nextstep = nextStep.nodeId;
        // this.form.auditers = JSON.stringify([{
        //   [nextStep.nodeId]: {
        //     userId: nextStep.id,
        //     userName: nextStep.text,
        //   },
        // }]);
      });
    },
    // 图片上传
    modeUpload(item) {
      this.mode.push(item.file);
      // console.log('fileList', this.mode);
    },
    zsubmitForm() {
      // 上传图片
      const fd = new FormData();
      // fd.append('file', this.mode);
      const params = {
        processId: this.selectProcessInfo.F_Id, // 工单id
        nodeId: this.selectProcessInfo.F_NodeId, // 节点id
      };
      for (let a = 0; a < this.mode.length; a += 1) {
        fd.append('file', this.mode[a], this.mode[a].name);
      }
      uploadImagesGD(fd, params).then(() => {
        this.$refs.upload.clearFiles();
        this.mode = [];
        this.notifyDataChanged();
        this.emitCloseDialog();
        // console.log('上传成功');
      });
    },
    // 文件操作改变时重新验证
    handleOnChange() {
    // zform为表单名
    // this.$refs.zform.validateField('file');
    },
    // eslint-disable-next-line consistent-return
    handleBeforeUpload(file) {
      // const extension = file.name.substring(file.name.lastIndexOf('.') + 1);
      const size = file.size / 1024 / 1024;
      if (size > 2) {
        this.$message.warning(
          '您上传的文件大小已超出2M',
        );
        this.$refs.upload.clearFiles();
        // this.$myTools.showMessage('warning', '文件大小不得超过0.1M');
        this.mode = [];
        this.$refs.zform.validateField('file');
        return false;
      }
    },
    // 限制传文件个数
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`,
      );
    },
    // 上传文件移除事件
    beforeRemove() {
      // return this.$confirm(`确定移除 ${file.name}？`);
    },
  },
};
</script>
